import * as React from 'react';

import { useMediaQuery, useTheme } from '@mui/material';

import { track } from '@hbf/analytics';

import { AnalyticsEvent } from '@kamernet/core/Analytics/types';
import { ListingDetails } from '@kamernet/core/ApiClient/Kamernet';
import { PageLayout } from '@kamernet/core/PageLayout';

import { ListingDetailsProvider } from '../../ListingDetailsProvider';
import { About } from '../About/About';
import { ContactLandlordMobile } from '../ContactLandlord/ContactLandlordMobile';
import { Details } from '../Details/Details';
import { Gallery } from '../Gallery/Gallery';
import { Header } from '../Header/Header';
import { IdealTenant } from '../IdealTenant/IdealTenant';
import { LandlordInfo } from '../LandlordInfo/LandlordInfo';
import { LightboxWrapper } from '../LightBoxWrapper';
import { Map } from '../Map/Map';
import { Overview } from '../Overview/Overview';
import { PropertyDetails } from '../PropertyDetails';
import { RentalCosts } from '../RentalCosts/RentalCosts';
import { SimilarPlacesGrid } from '../SimilarPlacesGrid/SimilarPlacesGrid';

import styles from './ListingFound.module.css';

export interface ListingFoundProps {
  listingDetails: ListingDetails;
}

export const ListingFound = ({ listingDetails }: ListingFoundProps) => {
  const [showLightBox, setShowLightBox] = React.useState(false);
  const theme = useTheme();
  const isSMDown = useMediaQuery(theme.breakpoints.down('sm'));

  React.useEffect(() => {
    track(AnalyticsEvent.ViewContent, {});
  }, []);

  const openLightBox = React.useCallback(() => {
    setShowLightBox(true);
  }, []);

  const closeLightBox = React.useCallback(() => {
    setShowLightBox(false);
  }, []);

  return (
    <PageLayout.MainContainer>
      <ListingDetailsProvider listingDetails={listingDetails}>
        <React.Fragment>
          <Header />
          <div className={styles.gridContainer}>
            <div className={styles.leftColumn}>
              <Gallery onOpenLightBox={openLightBox} />
              {showLightBox && <LightboxWrapper onClose={closeLightBox} />}
              <About />
              {isSMDown && <PropertyDetails />}
              <Details />
              <RentalCosts />
              <Map />
              <IdealTenant />
              <LandlordInfo />
            </div>
            <div className={styles.rightColumn}>
              <Overview />
            </div>
          </div>
          {listingDetails.suggestedListingResult &&
            listingDetails.suggestedListingResult.length > 0 && (
              <SimilarPlacesGrid />
            )}
          {isSMDown && <ContactLandlordMobile />}
        </React.Fragment>
      </ListingDetailsProvider>
    </PageLayout.MainContainer>
  );
};
